import React from "react";
import { useTranslation } from "react-i18next";

const RequirementIndicator = ({ met, text }) => {
  const { t } = useTranslation();
  return (
    <li className="d-flex align-items-center mb-1">
      {met ? (
        <i
          className="bi bi-check-circle-fill text-success me-2"
          aria-hidden="true"
        ></i>
      ) : (
        <i
          className="bi bi-x-circle-fill text-danger me-2"
          aria-hidden="true"
        ></i>
      )}
      <span className={met ? "text-success" : "text-danger"}>
        <span className="visually-hidden">
          {met
            ? t("passwordRequirements.met", "Requirement met: ")
            : t("passwordRequirements.notMet", "Requirement not met: ")}
        </span>
        {text}
      </span>
    </li>
  );
};

function PasswordRequirements({ password = "" }) {
  const { t } = useTranslation();
  const v = {
    minLength: password.length >= 8,
    maxLength: password.length <= 20,
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  return (
    <div className="form-text mt-2">
      <small className="fw-semibold">
        {t("passwordRequirements.title", "Password must contain:")}
      </small>
      <ul
        className="mb-0 ps-0 mt-2"
        style={{ fontSize: "0.875rem", listStyle: "none" }}
      >
        <RequirementIndicator
          met={v.minLength}
          text={t("passwordRequirements.minLength", "At least 8 characters")}
        />
        <RequirementIndicator
          met={v.maxLength}
          text={t("passwordRequirements.maxLength", "Maximum 20 characters")}
        />
        <RequirementIndicator
          met={v.hasUppercase}
          text={t(
            "passwordRequirements.uppercase",
            "At least one uppercase letter (A-Z)",
          )}
        />
        <RequirementIndicator
          met={v.hasLowercase}
          text={t(
            "passwordRequirements.lowercase",
            "At least one lowercase letter (a-z)",
          )}
        />
        <RequirementIndicator
          met={v.hasNumber}
          text={t("passwordRequirements.number", "At least one number (0-9)")}
        />
        <RequirementIndicator
          met={v.hasSpecialChar}
          text={t(
            "passwordRequirements.specialChar",
            "At least one special character (!@#$%^&*...)",
          )}
        />
      </ul>
    </div>
  );
}

export default PasswordRequirements;
